import React, { useMemo } from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Unauthorized from "../general/Unauthorized";
import axios from '../../axios/axiosconf';
import { useEffect, useState, useCallback } from "react";
import Loading from "../general/Loading";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Modal, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { usuarioTieneFirma, usuarioTieneRegistro } from "../../../resources/Helper";
import { useClientPagination } from "../reportes/useClientPagination";
import ReportPaginationFooter from "../reportes/ReportPaginationFooter";
import { debeFiltrarPorProfesional, getUserData, usuarioPuedeIniciarAtencion } from "../../../utils/userAccessHelpers";

function ListarPacientes() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [permisos, setPermisos] = useState([]);
    const [showModalCompletarInfo, setShowModalCompletarInfo] = useState(false);
    const [showModalAcciones, setShowModalAcciones] = useState(false);
    const [pacienteAccion, setPacienteAccion] = useState(null);
    let userdata = [];
    let clientData = [];
    let history = useHistory();

    const [filtroNombre, setFiltroNombre] = useState('');
    const [filtroDocumento, setFiltroDocumento] = useState('');
    const [filtroFechaIngreso, setFiltroFechaIngreso] = useState('');
    const [filtroConvenio, setFiltroConvenio] = useState('');
    const [convenios, setConvenios] = useState([]);

    const [showToast, setShowToast] = useState(false);
    const [recargandoPacientes, setRecargandoPacientes] = useState(false);

    /** Colapsa espacios y quita tildes para comparar búsqueda vs datos guardados con espacios extra. */
    const normalizarParaBusqueda = (texto) => {
        if (texto == null || texto === '') return '';
        return String(texto)
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, ' ')
            .trim();
    };

    const coincideNombreBusqueda = (nombreCompleto, filtro) => {
        const termino = normalizarParaBusqueda(filtro);
        if (!termino) return true;
        const base = normalizarParaBusqueda(nombreCompleto);
        if (base.includes(termino)) return true;
        const palabras = termino.split(' ').filter(Boolean);
        return palabras.every((palabra) => base.includes(palabra));
    };

    const getNombreCompleto = (row) => {
        return [
            row.primer_nombre,
            getNombre(row.segundo_nombre),
            row.primer_apellido,
            getNombre(row.segundo_apellido)
        ]
            .map((parte) => (parte != null ? String(parte).trim() : ''))
            .filter((parte) => parte !== '')
            .join(' ');
    }

    const cols = [
        { 
            name: 'Nombre', 
            selector: row => getNombreCompleto(row), 
            sortable: true,
            grow: 1.6,
            cell: row => <span className="patient-name-cell" title={getNombreCompleto(row)}>{getNombreCompleto(row)}</span>
        },
        { name: 'Documento', selector: row => row.numero_documento, sortable: false, grow: 0.9 },
        { name: 'Email', selector: row => row.email, sortable: false, grow: 1.1 },
        { name: 'Celular', selector: row => row.celular, sortable: false, grow: 0.85 },
        { name: 'Acción', center: true, cell: row => getBotones(row), grow: 0.65 }
    ];

    const getNombre = (nombre) => {
        return nombre != null ? nombre : '';
    }

    const getBotones = (item) => {
        return (
            <button
                type="button"
                className="btn btn-sm patient-icon-btn patient-icon-btn--menu"
                title="Opciones"
                onClick={() => {
                    setPacienteAccion(item);
                    setShowModalAcciones(true);
                }}
            >
                <i className="fas fa-ellipsis-h"></i>
            </button>
        );
    }

    const customTableStyles = useMemo(() => ({
        table: { style: { backgroundColor: '#fff' } },
        headRow: {
            style: {
                minHeight: '44px',
                borderBottom: '1px solid #e9eef3',
                backgroundColor: '#fafcfe'
            }
        },
        headCells: {
            style: {
                fontSize: '12px',
                fontWeight: 700,
                color: '#5f6b77',
                textTransform: 'uppercase',
                letterSpacing: '0.02em',
                paddingTop: '10px',
                paddingBottom: '10px'
            }
        },
        rows: {
            style: {
                minHeight: '52px',
                borderBottom: '1px solid #f1f4f8'
            }
        },
        cells: {
            style: {
                fontSize: '13px',
                color: '#2f3a45'
            }
        },
        pagination: {
            style: {
                borderTop: '1px solid #eef2f6',
                minHeight: '50px'
            }
        }
    }), []);

    const cargarPacientes = useCallback(() => {
        const userdataActual = getUserData();
        if (!userdataActual?.user_id) {
            return Promise.resolve();
        }

        const parametrosFiltro = {
            uid: userdataActual.user_id,
            solo_pacientes: true,
        };

        if (debeFiltrarPorProfesional(userdataActual)) {
            parametrosFiltro.solo_mis_pacientes = true;
        }

        setRecargandoPacientes(true);

        return axios.get('/pacientes', { params: parametrosFiltro })
            .then((response) => {
                if (response.status === 200) {
                    setItems(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setRecargandoPacientes(false);
            });
    }, []);

    useEffect(() => {

        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true); // ✅ Marcar como cargado para mostrar Unauthorized
            return; // Detener si no hay datos de usuario
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));
        setPermisos(userdata.up || []);

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a listar pacientes
        const tienePermiso = userdata.up && userdata.up.includes('crearPacientes');

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true); // ✅ Marcar como cargado para mostrar Unauthorized
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setUsername(userdata.user_name);

                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {

                console.log(error);
            });

        cargarPacientes();

        axios.get('/convenios')
            .then(response => {
                if (response.status === 200) {
                    setConvenios(response.data || []);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }, [cargarPacientes]);

    useEffect(() => {
        const onVistaPiChanged = () => {
            cargarPacientes();
        };
        window.addEventListener('smile-vista-pi-changed', onVistaPiChanged);
        return () => window.removeEventListener('smile-vista-pi-changed', onVistaPiChanged);
    }, [cargarPacientes]);


    const itemsFiltrados = useMemo(() => {
        const nombreFiltro = filtroNombre.trim();
        const documentoFiltro = normalizarParaBusqueda(filtroDocumento).replace(/\s/g, '');
        const fechaFiltro = filtroFechaIngreso;
        const convenioFiltro = filtroConvenio;

        return items.filter((item) => {
            const nombreCompleto = getNombreCompleto(item);
            const numeroDocumento = normalizarParaBusqueda(item.numero_documento || '').replace(/\s/g, '');
            const fechaIngreso = item.fechaingreso ? item.fechaingreso.slice(0, 10) : '';
            const convenioPaciente = item.convenio != null && item.convenio !== '' ? String(item.convenio) : '';

            const coincideNombre = coincideNombreBusqueda(nombreCompleto, nombreFiltro);
            const coincideDocumento = !documentoFiltro || numeroDocumento.includes(documentoFiltro);
            const coincideFecha = !fechaFiltro || fechaIngreso === fechaFiltro;
            const coincideConvenio = !convenioFiltro || convenioPaciente === String(convenioFiltro);

            return coincideNombre && coincideDocumento && coincideFecha && coincideConvenio;
        });
    }, [items, filtroNombre, filtroDocumento, filtroFechaIngreso, filtroConvenio]);

    const pagination = useClientPagination(itemsFiltrados);

    const nuevosMes = useMemo(() => {
        const hoy = new Date();
        const mesActual = hoy.getMonth();
        const anioActual = hoy.getFullYear();

        return items.filter((item) => {
            if (!item.fechaingreso) return false;
            const fecha = new Date(item.fechaingreso);
            return fecha.getMonth() === mesActual && fecha.getFullYear() === anioActual;
        }).length;
    }, [items]);

    const pacientesConEmail = useMemo(() => items.filter(item => !!item.email).length, [items]);
    const pacientesCompletos = useMemo(() => items.filter(item => String(item.estado) !== '0').length, [items]);

    const handleCloseModalInfo = () => setShowModalCompletarInfo(false);
    const handleCompletarInfo = () => history.push('/configuracion');
    const handleCloseModalAcciones = () => {
        setShowModalAcciones(false);
        setPacienteAccion(null);
    };

    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (loggedIn && hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn && hasPermission) {
        return (

            <div className="hold-transition patient-list-page">
                <Header client={client} />
                <Aside client={client} activelink="patients" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/menu-pacientes">Pacientes</Link></li>
                                        <li className="breadcrumb-item" key="bc3">Listar Pacientes</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-12 d-flex flex-wrap align-items-center justify-content-between">
                                    <h1 className="m-0 patient-main-title">Pacientes</h1>
                                    <div className="d-flex flex-wrap align-items-center" style={{ gap: '8px' }}>
                                        <span className="badge patient-soft-badge">
                                            {itemsFiltrados.length} registros
                                        </span>
                                        <span className="badge patient-soft-badge patient-soft-badge--teal">
                                            +{nuevosMes} nuevos este mes
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">


                            <div className="row patient-filters-row">
                                <div className="col-12 mb-3">
                                    <div className="row">
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <div className="patient-kpi-card">
                                                <div className="patient-kpi-icon"><i className="fas fa-users"></i></div>
                                                <div className="patient-kpi-value">{items.length}</div>
                                                <div className="patient-kpi-label">Total pacientes</div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <div className="patient-kpi-card">
                                                <div className="patient-kpi-icon"><i className="fas fa-user-plus"></i></div>
                                                <div className="patient-kpi-value">{nuevosMes}</div>
                                                <div className="patient-kpi-label">Nuevos este mes</div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <div className="patient-kpi-card">
                                                <div className="patient-kpi-icon"><i className="fas fa-envelope"></i></div>
                                                <div className="patient-kpi-value">{pacientesConEmail}</div>
                                                <div className="patient-kpi-label">Con email</div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <div className="patient-kpi-card">
                                                <div className="patient-kpi-icon"><i className="fas fa-user-check"></i></div>
                                                <div className="patient-kpi-value">{pacientesCompletos}</div>
                                                <div className="patient-kpi-label">Perfiles completos</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="patient-filters-box">
                                        <div className="row align-items-end patient-filters-fields">
                                <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="form-group patient-filter-group">
                                        <label htmlFor="filtroNombre">Nombre</label>
                                        <input
                                            type="text"
                                            id="filtroNombre"
                                            className="form-control"
                                            placeholder="Buscar por nombre..."
                                            value={filtroNombre}
                                            onChange={(e) => setFiltroNombre(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-4 col-sm-6 patient-filter-col-compact">
                                    <div className="form-group patient-filter-group">
                                        <label htmlFor="filtroDocumento">Documento</label>
                                        <input
                                            type="text"
                                            id="filtroDocumento"
                                            className="form-control"
                                            placeholder="Nº documento..."
                                            value={filtroDocumento}
                                            onChange={(e) => setFiltroDocumento(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-4 col-sm-6 patient-filter-col-compact">
                                    <div className="form-group patient-filter-group">
                                        <label htmlFor="filtroFechaIngreso">Fecha ingreso</label>
                                        <input
                                            type="date"
                                            id="filtroFechaIngreso"
                                            className="form-control"
                                            value={filtroFechaIngreso}
                                            onChange={(e) => setFiltroFechaIngreso(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-4 col-sm-6 patient-filter-col-compact">
                                    <div className="form-group patient-filter-group">
                                        <label htmlFor="filtroConvenio">Convenio</label>
                                        <select
                                            id="filtroConvenio"
                                            className="form-control"
                                            value={filtroConvenio}
                                            onChange={(e) => setFiltroConvenio(e.target.value)}
                                        >
                                            <option value="">Todos</option>
                                            {convenios.map((item) => (
                                                <option key={`conv-${item.id}`} value={item.id}>{item.nombre}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-12 patient-create-col">
                                    <div className="form-group w-100 patient-filter-group">
                                        <label className="patient-create-label-placeholder">Acción</label>
                                        {permisos.includes('crearPacientes') &&
                                            <Link to={'/crear-paciente'} className={'btn btn-success btn-block patient-create-btn'}>Crear Paciente</Link>
                                        }
                                    </div>
                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-12" style={{ boxShadow: '0 0 14px rgba(0,0,0,0.09)', backgroundColor: 'white' }}>

                                    <DataTable
                                        columns={cols}
                                        data={pagination.paginatedItems}
                                        customStyles={customTableStyles}
                                        noDataComponent="No hay registros para mostrar"
                                        progressPending={recargandoPacientes}
                                        progressComponent={
                                            <div className="py-4 text-secondary font-weight-bold">
                                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                Cargando Pacientes…
                                            </div>
                                        }
                                        id={'tabla-pacientes'}
                                    />

                                    <ReportPaginationFooter
                                        totalRegistros={pagination.totalRegistros}
                                        indicePrimerRegistro={pagination.indicePrimerRegistro}
                                        indiceUltimoRegistro={pagination.indiceUltimoRegistro}
                                        paginaActual={pagination.paginaActual}
                                        cambiarPagina={pagination.cambiarPagina}
                                        totalPaginas={pagination.totalPaginas}
                                        registrosPorPagina={pagination.registrosPorPagina}
                                        onPageSizeChange={pagination.handlePageSizeChange}
                                        itemLabel="pacientes"
                                    />

                                </div>
                            </div>

                        </div>
                    </section>
                </div>

                <Modal show={showModalCompletarInfo} onHide={handleCloseModalInfo}>
                    <Modal.Header closeButton>
                        <Modal.Title>Aún no puedes atender citas</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Para atender una cita debes completar la siguiente información:</p>
                        <ul>
                            {!usuarioTieneFirma() ? <li>Firma</li> : <></>}
                            {!usuarioTieneRegistro() ? <li>Registro médico</li> : <></>}
                        </ul>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModalInfo}>Cancelar</Button>
                        <Button variant="primary" onClick={handleCompletarInfo}>Completar información</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showModalAcciones} onHide={handleCloseModalAcciones} centered dialogClassName="patient-actions-modal">
                    <Modal.Header className="patient-actions-modal__header">
                        <Modal.Title className="patient-actions-modal__title">
                            <span className="patient-actions-modal__title-icon">
                                <i className="fas fa-user-cog"></i>
                            </span>
                            Acciones del Paciente
                        </Modal.Title>
                        <button type="button" className="patient-actions-modal__close" onClick={handleCloseModalAcciones}>
                            <i className="fas fa-times"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body className="patient-actions-modal__body">
                        {pacienteAccion && (
                            <>
                                <div className="patient-actions-modal__patient">
                                    <span className="patient-actions-modal__avatar">
                                        {getNombreCompleto(pacienteAccion).trim().charAt(0).toUpperCase()}
                                    </span>
                                    <div>
                                        <div className="patient-actions-modal__patient-name">{getNombreCompleto(pacienteAccion)}</div>
                                        <div className="patient-actions-modal__patient-doc">
                                            Doc: {pacienteAccion.numero_documento || 'Sin documento'}
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-column" style={{ gap: '9px' }}>
                                    {permisos.includes('crearPacientes') && (
                                        <Link
                                            to={'/editar-paciente?id=' + pacienteAccion.id}
                                            className="btn patient-modal-action patient-modal-action--edit"
                                            onClick={handleCloseModalAcciones}
                                        >
                                            <i className="far fa-edit mr-2"></i>
                                            {pacienteAccion.estado != '0' ? 'Editar' : 'Completar datos'}
                                        </Link>
                                    )}
                                    <Link
                                        to={'/estado-cuenta-paciente?id=' + pacienteAccion.id}
                                        className="btn patient-modal-action patient-modal-action--wallet"
                                        onClick={handleCloseModalAcciones}
                                    >
                                        <i className="fas fa-dollar-sign mr-2"></i>
                                        Cartera
                                    </Link>
                                    {permisos.includes('atenderPacientes') && (
                                        usuarioPuedeIniciarAtencion() ? (
                                            <Link
                                                to={'/atender-paciente?id=' + pacienteAccion.id}
                                                className="btn patient-modal-action patient-modal-action--care"
                                                onClick={handleCloseModalAcciones}
                                            >
                                                <i className="fas fa-user-md mr-2"></i>
                                                Atención
                                            </Link>
                                        ) : (
                                            <button
                                                type="button"
                                                className="btn patient-modal-action patient-modal-action--care"
                                                onClick={() => {
                                                    handleCloseModalAcciones();
                                                    setShowModalCompletarInfo(true);
                                                }}
                                            >
                                                <i className="fas fa-user-md mr-2"></i>
                                                Atención
                                            </button>
                                        )
                                    )}
                                </div>
                            </>
                        )}
                    </Modal.Body>
                </Modal>

                <Footer showToast={false} delay={0} />

                <style>{`
                    .patient-list-page .patient-main-title {
                        font-size: 1.55rem !important;
                        font-weight: 700 !important;
                        color: #2b3440 !important;
                    }
                    .patient-list-page .patient-soft-badge {
                        background: rgba(23, 162, 184, 0.13);
                        color: #12798a;
                        border: 1px solid rgba(23, 162, 184, 0.25);
                        border-radius: 999px;
                        font-weight: 700;
                        padding: 0.34rem 0.65rem;
                        font-size: 0.76rem;
                    }
                    .patient-list-page .patient-soft-badge--teal {
                        background: rgba(40, 167, 69, 0.11);
                        color: #1f7d46;
                        border-color: rgba(40, 167, 69, 0.2);
                    }
                    .patient-list-page .patient-name-cell {
                        font-weight: 600;
                        color: #26313b;
                    }
                    .patient-list-page .patient-kpi-card {
                        background: #fff;
                        border: 1px solid #e8edf2;
                        border-radius: 14px;
                        padding: 14px 16px;
                        box-shadow: 0 6px 16px rgba(29, 45, 61, 0.05);
                    }
                    .patient-list-page .patient-kpi-icon {
                        width: 34px;
                        height: 34px;
                        border-radius: 10px;
                        background: rgba(23, 162, 184, 0.12);
                        color: #168394;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 8px;
                    }
                    .patient-list-page .patient-kpi-value {
                        font-size: 1.45rem;
                        line-height: 1.1;
                        font-weight: 700;
                        color: #26323f;
                    }
                    .patient-list-page .patient-kpi-label {
                        font-size: 0.8rem;
                        color: #70808f;
                        font-weight: 600;
                    }
                    .patient-list-page .patient-icon-btn {
                        border: 1px solid transparent;
                        border-radius: 10px;
                        width: 31px;
                        height: 31px;
                        padding: 0;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        transition: all .15s ease;
                    }
                    .patient-list-page .patient-icon-btn i {
                        font-size: 12px;
                    }
                    .patient-list-page .patient-icon-btn--menu {
                        background: rgba(50, 58, 69, 0.1);
                        border-color: rgba(50, 58, 69, 0.18);
                        color: #2f3945;
                    }
                    .patient-list-page .patient-icon-btn--menu:hover {
                        background: rgba(50, 58, 69, 0.16);
                        color: #202830;
                        transform: translateY(-1px);
                    }
                    .patient-list-page .patient-create-btn {
                        border-radius: 10px;
                        font-weight: 700;
                        min-height: 38px;
                    }
                    .patient-list-page .patient-create-label-placeholder {
                        visibility: hidden;
                        display: block;
                        margin-bottom: 0.5rem;
                        font-size: 0.86rem;
                        line-height: 1.4;
                    }
                    .patient-list-page .patient-filters-row {
                        display: flex;
                        align-items: flex-end;
                    }
                    .patient-list-page .patient-filters-box {
                        background: #fff;
                        border: 1px solid #e8edf2;
                        border-radius: 12px;
                        padding: 12px 12px 10px;
                        margin-bottom: 10px;
                        box-shadow: 0 4px 12px rgba(29, 45, 61, 0.04);
                    }
                    .patient-list-page .patient-filters-fields {
                        flex-wrap: nowrap;
                    }
                    @media (max-width: 991.98px) {
                        .patient-list-page .patient-filters-fields {
                            flex-wrap: wrap;
                        }
                    }
                    .patient-list-page .patient-filter-col-compact label {
                        font-size: 0.82rem;
                    }
                    .patient-list-page .patient-filter-col-compact input.form-control,
                    .patient-list-page .patient-filter-col-compact select.form-control {
                        font-size: 0.86rem;
                        padding-left: 0.55rem;
                        padding-right: 0.55rem;
                    }
                    .patient-list-page .patient-filter-group select.form-control {
                        min-height: 38px;
                        box-sizing: border-box;
                    }
                    .patient-list-page .patient-filter-group {
                        margin-bottom: 0;
                    }
                    .patient-list-page .patient-filter-group label {
                        min-height: 22px;
                        display: inline-flex;
                        align-items: flex-end;
                        margin-bottom: 0.45rem;
                    }
                    .patient-list-page .patient-filter-group input.form-control {
                        min-height: 38px;
                        box-sizing: border-box;
                    }
                    .patient-list-page .patient-filter-group input[type="date"].form-control {
                        line-height: 1.25;
                    }
                    .patient-list-page .patient-create-col {
                        display: flex;
                        align-items: center;
                    }
                    .patient-list-page .patient-create-col .patient-filter-group {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        height: 100%;
                        padding-bottom: 4px;
                    }
                    .patient-modal-action {
                        border-radius: 12px;
                        font-weight: 700;
                        text-align: left;
                        border: 1px solid transparent;
                        min-height: 42px;
                        transition: all .16s ease;
                        background: transparent;
                        color: #47525e;
                    }
                    .patient-modal-action--edit {
                        border-color: transparent;
                    }
                    .patient-modal-action--wallet {
                        border-color: transparent;
                    }
                    .patient-modal-action--care {
                        border-color: transparent;
                    }
                    .patient-modal-action:hover {
                        transform: translateY(-1px);
                        box-shadow: none;
                        background: rgba(50, 58, 69, 0.07);
                        border-color: rgba(50, 58, 69, 0.08);
                    }
                    .patient-modal-action--edit:hover {
                        color: #3f4a56;
                    }
                    .patient-modal-action--wallet:hover {
                        color: #0f7281;
                    }
                    .patient-modal-action--care:hover {
                        color: #283242;
                    }
                    .patient-modal-action i {
                        width: 18px;
                        text-align: center;
                    }
                    .patient-modal-action--edit i {
                        color: #7b8794;
                    }
                    .patient-modal-action--wallet i {
                        color: #11a0b4;
                    }
                    .patient-modal-action--care i {
                        color: #2f3f52;
                    }
                    .patient-actions-modal .modal-content {
                        border: none;
                        border-radius: 14px;
                        box-shadow: 0 18px 40px rgba(20, 33, 48, 0.28);
                        overflow: hidden;
                    }
                    .patient-actions-modal__header {
                        border-bottom: 1px solid #edf2f7;
                        padding: 12px 14px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                    .patient-actions-modal__title {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        font-size: 1.1rem;
                        font-weight: 700;
                        color: #2b3440;
                    }
                    .patient-actions-modal__title-icon {
                        width: 28px;
                        height: 28px;
                        border-radius: 8px;
                        background: rgba(23, 162, 184, 0.13);
                        color: #148495;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 0.88rem;
                    }
                    .patient-actions-modal__close {
                        border: 0;
                        background: rgba(50, 58, 69, 0.08);
                        color: #4b5663;
                        width: 30px;
                        height: 30px;
                        border-radius: 999px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .patient-actions-modal__close:hover {
                        background: rgba(50, 58, 69, 0.15);
                        color: #28313a;
                    }
                    .patient-actions-modal__body {
                        padding: 14px;
                    }
                    .patient-actions-modal__patient {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        margin-bottom: 12px;
                        padding: 10px;
                        border: 1px solid #edf2f7;
                        border-radius: 11px;
                        background: #fafcfe;
                    }
                    .patient-actions-modal__avatar {
                        width: 34px;
                        height: 34px;
                        border-radius: 50%;
                        background: rgba(23, 162, 184, 0.16);
                        color: #147f90;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        font-weight: 700;
                    }
                    .patient-actions-modal__patient-name {
                        font-size: 0.9rem;
                        font-weight: 700;
                        color: #2e3742;
                        line-height: 1.2;
                    }
                    .patient-actions-modal__patient-doc {
                        font-size: 0.76rem;
                        color: #6f7d8b;
                        margin-top: 2px;
                    }
                    @media (max-width: 768px) {
                        .patient-list-page .patient-kpi-card {
                            padding: 12px 14px;
                        }
                    }
                `}</style>
            </div>

        );
    }

    return (
        <Loading />
    );
}
export default ListarPacientes;